import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import BookingPage from "./pages/BookingPage";
import BookingConfirmation from "./pages/BookingConfirmation";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/book/:bookingLink" element={<BookingPage />} />
          <Route path="/confirmation" element={<BookingConfirmation />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
